import { Paper, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';

const NotFoundType = ({productTypeName}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";
    return (
        <>
            <Paper sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h6" color="warning.main">
                    {isArabic
                        ? `نوع المنتج "${productTypeName}" غير مدعوم حالياً`
                        : `Product type "${productTypeName}" is not supported yet`}
                </Typography>
            </Paper>
        </>
    )
}

export default NotFoundType